module.exports = __webpack_public_path__ + "static/media/esd.45088d61.png";